export enum ClientTypes {
    INTERNAL = "INTERNAL",
    EXTERNAL = "EXTERNAL",
    DEMO = "DEMO",
}
